import React from 'react';
import { CostCentre } from 'types/scenario';
import Text from '@ingka/text';
import classes from './CoworkerDetails.module.scss';

const CoworkerCostCentre = ({ costCentres, keyPrefix }: {
    costCentres: CostCentre[];
    keyPrefix: string
}) => (
    costCentres.map(costCentre => (
        <div
            data-testid="coworker-costCentre-value"
            key={`coworker-cost-center-${keyPrefix}-${costCentre.costCentre}`}
            className={costCentre.sourceIsPa ? '' : classes['scenario-details']}
        >
            <Text data-testid="coworker-costCentre-display-name" textStyle="LabelRegular.M">{costCentre.displayName}</Text>
        </div>
    ))
);

export default CoworkerCostCentre;
